import {VALIDATION_RULE} from './constants';
import * as japaneseService from './japaneseServices';
import {comparingDate} from '../Core/date';

let displayNameValidator = {
    message: '',
    invalid: false
};
let fullNameValidator = {
    message: '',
    invalid: false
};
let phoneNumberValidator = {
    message: '',
    invalid: false
};
let emailAddressValidator = {
    message: '',
    invalid: false
};

let birthDateValidator = {
    message: '',
    invalid: false
};

let scheduleDateValidator = {
    message: '',
    invalid: false
};
let notesValidator = {
    message: '',
    invalid: false
};
let productIdValidator = {
    message: '',
    invalid: false
}
const  _validateRequireFields = (form,i18n) => {
    displayNameValidator.invalid = !form.info.name || form.info.name.trim() == '';
    fullNameValidator.invalid = !form.info.fullName || form.info.fullName.trim() == '';
    phoneNumberValidator.invalid = !form.info.phoneNumber || form.info.phoneNumber == '';
    emailAddressValidator.invalid = !form.info.emailAddress || form.info.emailAddress == '';
    scheduleDateValidator.invalid = !form.info.scheduleDate || form.info.scheduleDate.from == null;
    birthDateValidator.invalid = !form.info.birthDate || form.info.birthDate.trim() == ''
    productIdValidator.invalid = !form.productId || form.productId == '';


    if( displayNameValidator.invalid)
        displayNameValidator.message=i18n.msg_required_name;
    if( fullNameValidator.invalid){
        fullNameValidator.message=i18n.msg_required_fullname;
    }

    
    if( phoneNumberValidator.invalid)
        phoneNumberValidator.message=i18n.msg_required_phone;

    if( birthDateValidator.invalid)
        birthDateValidator.message=i18n.msg_required_birthdate;

    if( emailAddressValidator.invalid)
        emailAddressValidator.message=i18n.msg_invalid_email;
    

    if( scheduleDateValidator.invalid)
        scheduleDateValidator.message=i18n.msg_booking_time_invalid;
    if( productIdValidator.invalid)
        productIdValidator.message=i18n.msg_required;
}
const _validateInvalidFields = (form,i18n) => {
    var re =VALIDATION_RULE.SPECIAL_CHARACTER.REGEX;
    if (!displayNameValidator.invalid ) {
        var displayName =form.info.name;
        var isValid = displayName.length <= VALIDATION_RULE.DISPLAY_NAME.MAX;
        if(!isValid){
            displayNameValidator.message=i18n.msg_invalid_maxlength_bookerName;
        }else
        {
            var invalidChars=japaneseService.getInvalidJapaneseCharacter(displayName);
            isValid = !re.test(displayName) &&!invalidChars;
            //console.log(checkHasWhiteSpace(displayName));
            if(!isValid){
                var msg = i18n.msg_invalid_customer_name;
                msg = msg.replace('%1', invalidChars);
                displayNameValidator.message=msg;
            }
        }
        displayNameValidator.invalid=!isValid;

    }

    if (!fullNameValidator.invalid) {
        var fullName =form.info.fullName;
        var isValid =   fullName.length <= VALIDATION_RULE.FULL_NAME.MAX;
        if(!isValid) {
            fullNameValidator.message = i18n.msg_invalid_maxlength_bookerName;
        }else
        {
            var invalidChars=japaneseService.getInvalidFuriganaCharacter(fullName);
            isValid = !re.test(fullName) &&!invalidChars;
            if(!isValid){
                var msg = i18n.msg_invalid_furigana_name;
                //msg = msg.replace('%1', invalidChars);
                fullNameValidator.message=msg;
            }
        }

        fullNameValidator.invalid=!isValid;
    }

    

    if ( !phoneNumberValidator.invalid) {
        var phoneNumber =form.info.phoneNumber;
        var re = VALIDATION_RULE.PHONE_NUMBER.REGEX;
        var isValid =validatePhone(phoneNumber) ;
        phoneNumberValidator.invalid= !isValid;
        if(!isValid){
            phoneNumberValidator.message=i18n.msg_invalid_phoneNumber_fukada;
        }
    }

    if (  !emailAddressValidator.invalid) {
        var re =VALIDATION_RULE.EMAIL.REGEX;
        var email =form.info.emailAddress;
        var isValid = re.test(email) && (email.length <= VALIDATION_RULE.EMAIL.MAX);
        emailAddressValidator.invalid= !isValid;
        if(!isValid){
            emailAddressValidator.message=i18n.msg_invalid_email;;
        }
    }

    if ( !birthDateValidator.invalid) {
        var birthDate =form.info.birthDate;
        var isValid = _validateDate(birthDate) ;
        birthDateValidator.invalid= !isValid;
        if(!isValid){
            birthDateValidator.message=i18n.msg_invalid_birthdate;
        }
    }


    if ( !notesValidator.invalid) {
        var isValid = form.info.notes.length <=  VALIDATION_RULE.NOTE.MAX;
        if(!isValid)
            notesValidator.message=i18n.msg_invalid_maxlength_notes;

        notesValidator.invalid=!isValid;
    }

}

const WHITE_SPACE = 0x0020;
const HALFWIDTH_WHITE_SPACE = 0x3000;


const checkHasWhiteSpace = (char) => {
    let check = false;
    for(let i = 0; i < char.length;i++){
        let theUnicode = char[i].charCodeAt(0) ;
        if(theUnicode==WHITE_SPACE || theUnicode==HALFWIDTH_WHITE_SPACE){
            check  = true;
        }
    }
    return check
}
const _getValidateData = (requireField) => {
    const defaultValue = {message : '', invalid: false};
    return {
        displayName: requireField.displayName ? displayNameValidator : defaultValue,
        fullName: requireField.fullName ?  fullNameValidator : defaultValue,
        phoneNumber: requireField.phone ? phoneNumberValidator : defaultValue,
        emailAddress: requireField.email ? emailAddressValidator : defaultValue,
        birthDate: requireField.birthDate ? birthDateValidator : defaultValue,
        scheduleDate: scheduleDateValidator,
        productId: productIdValidator,
        notes: notesValidator,
    }
}

const _successValidate = () => {
    displayNameValidator = {
        message: '',
        invalid: false
    };
    fullNameValidator = {
        message: '',
        invalid: false
    };
    phoneNumberValidator = {
        message: '',
        invalid: false
    };
    birthDateValidator = {
        message: '',
        invalid: false
    };
    emailAddressValidator = {
        message: '',
        invalid: false
    };
    scheduleDateValidator = {
        message: '',
        invalid: false
    };
    notesValidator = {
        message: '',
        invalid: false
    };
    productIdValidator = {
        message: '',
        invalid: false
    }
}
export const validateData =  (form,i18n, requireField) => {
    _successValidate();
    _validateRequireFields(form,i18n);
    _validateInvalidFields(form,i18n);

    form.dataValid = !displayNameValidator.invalid
        && !fullNameValidator.invalid && !phoneNumberValidator.invalid && !emailAddressValidator.invalid && !scheduleDateValidator.invalid
   && !productIdValidator.invalid;
   return _getValidateData(requireField);

}

export const isBookerInfoInvalid = () => {
    return   displayNameValidator.invalid
        || fullNameValidator.invalid || phoneNumberValidator.invalid || emailAddressValidator.invalid  || emailAddressValidator.notMatch ;
}

export const validatePhone = (phoneNumber) => {

    if  (phoneNumber.length > VALIDATION_RULE.PHONE_NUMBER.MAX)
         return false;
    var res =VALIDATION_RULE.PHONE_NUMBER.REGEX;
    var isValid =false;
    // remove space of phone number
    phoneNumber = phoneNumber.replace(/\s+/g, '');
    res.forEach(function (re) {
        if(!isValid)
          isValid = re.test(phoneNumber);            
        if(isValid)
            return isValid;

    });

    return isValid;
}

const _validateDate = (date) => {
    let formatDate = new Date(date),
        isValid = false;    
    if(formatDate !== 'Invalid Date'){
        if( comparingDate(new Date(), date) || comparingDate(date, '1900/01/01')) return false; 
        isValid = true;
    }    
    return isValid;
}